import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "html-before-input"
}

import {
    CLIENT_DATA_TYPE_CAPTCHA,
    CLIENT_DATA_TYPE_CHECKBOX,
    CLIENT_DATA_TYPE_DATE, CLIENT_DATA_TYPE_DATETIME,
    CLIENT_DATA_TYPE_EMAIL,
    CLIENT_DATA_TYPE_EULA,
    CLIENT_DATA_TYPE_FILE, CLIENT_DATA_TYPE_INTEGER, CLIENT_DATA_TYPE_NUMBER,
    CLIENT_DATA_TYPE_PHONE,
    CLIENT_DATA_TYPE_RADIO,
    CLIENT_DATA_TYPE_SELECT,
    CLIENT_DATA_TYPE_STARS, CLIENT_DATA_TYPE_SWITCH,
    CLIENT_DATA_TYPE_TEXT,
    CLIENT_DATA_TYPE_TEXTAREA, CLIENT_DATA_TYPE_TIME
} from "~/chat/ts/data/IClient";
import ChatTextInput from "~/chat/vue/widget/form/fields/ChatTextInput.vue";
import ChatCheckboxInput from "~/chat/vue/widget/form/fields/ChatCheckboxInput.vue";
import ChatDateInput from "~/chat/vue/widget/form/fields/ChatDateInput.vue";
import ChatTextareaInput from "~/chat/vue/widget/form/fields/ChatTextareaInput.vue";
import ChatFileInput from "~/chat/vue/widget/form/fields/ChatFileInput.vue";
import ChatRadioInput from "~/chat/vue/widget/form/fields/ChatRadioInput.vue";
import ChatSelectInput from "~/chat/vue/widget/form/fields/ChatSelectInput.vue";
import Dictionary from "~/ts/library/Dictionary";
import ChatEmailInput from "~/chat/vue/widget/form/fields/ChatEmailInput.vue";
import ChatEulaInput from "~/chat/vue/widget/form/fields/ChatEulaInput.vue";
import ChatRecaptcha from "~/chat/vue/widget/form/fields/ChatRecaptcha.vue";
import {ConfigStore} from "~/chat/ts/store/Config";
import ChatStarsInput from "~/chat/vue/widget/form/fields/ChatStarsInput.vue";
import {
    ChatFormInputInterface,
    useChatFormInput,
    useChatFormInputProps
} from "~/chat/vue/widget/form/fields/useChatFormInput";
import {Component, computed, defineAsyncComponent, ref} from "vue";
import ChatHtmlify from "~/chat/vue/misc/ChatHtmlify.vue";
import ChatTimeInput from "~/chat/vue/widget/form/fields/ChatTimeInput.vue";
import ChatIntegerInput from "~/chat/vue/widget/form/fields/ChatIntegerInput.vue";
import ChatNumberInput from "~/chat/vue/widget/form/fields/ChatNumberInput.vue";
import ChatSwitchInput from "~/chat/vue/widget/form/fields/ChatSwitchInput.vue";


const __default__ = {
    name: "ChatFormInput"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useChatFormInputProps()
},
  emits: ["continue", "update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {

let inputs: Dictionary<Component> = {
    [CLIENT_DATA_TYPE_TEXT]: ChatTextInput,
    [CLIENT_DATA_TYPE_CHECKBOX]: ChatCheckboxInput,
    [CLIENT_DATA_TYPE_DATE]: ChatDateInput,
    [CLIENT_DATA_TYPE_DATETIME]: ChatDateInput,
    [CLIENT_DATA_TYPE_TIME]: ChatTimeInput,
    [CLIENT_DATA_TYPE_TEXTAREA]: ChatTextareaInput,
    [CLIENT_DATA_TYPE_FILE]: ChatFileInput,
    [CLIENT_DATA_TYPE_RADIO]: ChatRadioInput,
    [CLIENT_DATA_TYPE_SELECT]: ChatSelectInput,
    [CLIENT_DATA_TYPE_PHONE]: defineAsyncComponent(() => import(/* webpackChunkName: "phone-input" */ '~/chat/vue/widget/form/fields/ChatPhoneInput.vue')),//ChatPhoneInput,
    [CLIENT_DATA_TYPE_EMAIL]: ChatEmailInput,
    [CLIENT_DATA_TYPE_EULA]: ChatEulaInput,
    [CLIENT_DATA_TYPE_CAPTCHA]: ChatRecaptcha,
    [CLIENT_DATA_TYPE_STARS]: ChatStarsInput,
    [CLIENT_DATA_TYPE_INTEGER]: ChatIntegerInput,
    [CLIENT_DATA_TYPE_NUMBER]: ChatNumberInput,
    [CLIENT_DATA_TYPE_SWITCH]: ChatSwitchInput
};

let props = __props;

let emits = __emit;

let {isContinueAvailable, exposedObject} = useChatFormInput(props);

let formComponent = computed<Component>(() => {
    let typeId = props.field.type;

    if (!ConfigStore.siteParams.value.params.leadGen.usePhoneNumbersMask) {
        if (typeId == CLIENT_DATA_TYPE_PHONE) {
            typeId = CLIENT_DATA_TYPE_TEXT;
        }
    }
    return inputs[typeId];
});

let input = ref<ChatFormInputInterface>();

function focus(): void {
    input.value?.focus();
}

function onContinueClick() {
    if (isContinueAvailable.value) {
        emits('continue');
    }
}

__expose<ChatFormInputInterface>({
    ...exposedObject,
    focus
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.required ? 'required' : '')
  }, [
    (_unref(formComponent))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_unref(props).field.isHtmlBeforeInputEnabled && _unref(props).field.htmlBeforeInput)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(ChatHtmlify, {
                  value: _unref(props).field.htmlBeforeInput,
                  escape: false
                }, null, 8, ["value"])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(formComponent)), _mergeProps(_unref(props), {
            ref_key: "input",
            ref: input,
            error: _ctx.error,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('update:modelValue', $event))),
            onContinue: onContinueClick
          }), null, 16, ["error"]))
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
}
}

})